import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/content";
import { SectionEyebrow } from "@/components/Marquee";

export default function FAQ() {
  return (
    <section id="faq" className="relative py-20 md:py-28 bg-void" data-testid="faq-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <SectionEyebrow n="Ch. XIV" testId="faq-eyebrow">Questions</SectionEyebrow>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1 }}
            className="mt-6 font-serif text-white text-5xl md:text-6xl leading-[1] tracking-tight"
          >
            Ask us <span className="italic gradient-text">anything.</span>
          </motion.h2>
          <p className="mt-6 text-silver/70 leading-relaxed">
            Straight answers to the 6 things buyers ask on every first call.
          </p>
          <p className="mt-8 text-sm text-silver/50">
            Still have questions?{" "}
            <a href="mailto:support@caarsaarthi.com" className="text-white underline hover:no-underline">
              support@caarsaarthi.com
            </a>
          </p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-white/10">
                <AccordionTrigger className="text-left font-serif text-xl md:text-2xl text-white hover:no-underline py-6" data-testid={`faq-item-${i}`}>
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-silver/75 leading-relaxed text-base pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
